<div class="ui-toasts" aria-live="polite" aria-atomic="false">
  @for (toast of toasts(); track toast.id) {
    <div class="ui-toast ui-toast--{{ toast.type }}" role="status">
      <span class="ui-toast__icon" aria-hidden="true">
        <ui-icon [name]="iconFor(toast.type)" size="sm" />
      </span>
      <div class="ui-toast__content">
        <span class="ui-toast__title">{{ toast.title }}</span>
        @if (toast.message) {
          <span class="ui-toast__message">{{ toast.message }}</span>
        }
      </div>
      <button
        type="button"
        class="ui-toast__close"
        aria-label="Fermer la notification"
        (click)="dismiss(toast.id)"
      >
        <ui-icon name="close" size="sm" />
      </button>
    </div>
  }
</div>
